export default {
  'trust:title': 'Excellent Quality',
  'trust:seals:pdj-title': 'Futter Tester.de',
  'trust:seals:klimaneutral-title': 'ClimatePartner',
  'trust:seals:trusted-shop-title': 'Trusted Shops',
  'trust:seals:trusted-shop-rating': '"VERY GOOD"',
  'trust:seals:trusted-shop-review': '4.89/5.00 with over 4,116 reviews',
  'trust:seals:ethical-award': 'Ethical Award',
  'trust:button': 'Our Promise',
  'trust:money-back-guarantee': '30-day money-back guarantee',
};
